export const userTableColumns = [
  {
    type: "text"
  },
  {
    type: "text"
  },
  {
    type: "number",
    format: {
      thousandSeparated: true
    }
  },
  {
    type: "number",
    format: {
      thousandSeparated: true
    }
  },
  {
    type: "number",
    format: {
      thousandSeparated: true
    }
  },
  {
    type: "number",
    format: {
      thousandSeparated: true
    }
  }
];

export const storeTableColumns = [
  {
    type: "text"
  },
  {
    type: "number",
    format: {
      thousandSeparated: true
    }
  },
  {
    type: "number",
    format: {
      thousandSeparated: true
    }
  },
  {
    type: "number",
    format: {
      thousandSeparated: true
    }
  },
  {
    type: "number",
    format: {
      thousandSeparated: true
    }
  },
  {
    type: "number",
    format: {
      thousandSeparated: true
    }
  }
];

export const userTableHeaders = [
  "Name",
  "Email",
  "Last 180 days",
  "Last 90 days",
  "Last 60 days",
  "Last 30 days"
];

export const storeTableHeaders = [
  "Store",
  "Last 180 days",
  "Last 90 days",
  "Last 30 days",
  "Last 7 days",
  "Prior day"
];

export const userActivityDetailsHeaders = [
  "Name",
  "Email",
  "Last Login Date",
  "Previous Login Date",
  "Avg # of Logins/Month"
];

export const userActivityDetailsColumns = [
  {
    type: "text"
  },
  {
    type: "text"
  },
  {
    type: "text"
  },
  {
    type: "text"
  },
  {
    type: "number",
    format: {
      thousandSeparated: true
    }
  }
];

export const daysSinceLastLoginColumns = [
  {
    type: "text"
  },
  {
    type: "text"
  },
  {
    type: "number",
    format: {
      thousandSeparated: true
    }
  }
];

export const topNumberOfLoginsColumns = [
  {
    type: "text"
  },
  {
    type: "text"
  },
  {
    type: "number",
    format: {
      thousandSeparated: true
    }
  }
];
